/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { runGet } from "../../funcs/runGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetRunRunRunIdGetRequest$inboundSchema,
};

export const tool$runGet: ToolDefinition<typeof args> = {
  name: "run-get",
  description: `Get Run`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await runGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
